import { createFileRoute } from '@tanstack/react-router';
import { PlatformSecurityEditor } from '../../pages/platform/security/PlatformSecurityEditor';

// Política de seguridad de la PLATAFORMA misma (no de un tenant del catálogo). La ficha platform es un
// tenant más, así que su política de seguridad vive en el mismo endpoint `/tenants/{tenantId}/security-policy`
// con tenantId='platform'. Hereda el guard de scope PLATFORM del layout padre (_layout.platform).
export const Route = createFileRoute('/_authenticated/_layout/platform/security')({
    component: () => <PlatformSecurityEditor />,
});
